import React, { useEffect, useRef, useState } from 'react';

const ReadMoreButton = () => {
  const underlineRef = useRef(null);
  const [inView, setInView] = useState(false);

  // Scroll animation trigger
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (underlineRef.current) observer.observe(underlineRef.current);
    return () => underlineRef.current && observer.unobserve(underlineRef.current);
  }, []);

  return (
    <div className="read-more-container" ref={underlineRef}>
      <button className="read-more-btn">Read More</button>
      <div className={`underline-animation ${inView ? 'animate' : ''}`}></div>
    </div>
  );
};

export default ReadMoreButton;
